/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} CompaniesInputs */

const en_companies = /** @type {(inputs: CompaniesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Companies`)
};

const de_companies = /** @type {(inputs: CompaniesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unternehmen`)
};

/**
* | output |
* | --- |
* | "Companies" |
*
* @param {CompaniesInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const companies = /** @type {((inputs?: CompaniesInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<CompaniesInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_companies(inputs)
	return en_companies(inputs)
});